<script lang="ts">
	import type { OperationModel } from '@app/models/api/OperationModel';
	import DecisionTool from '@app/components/decision-tool/DecisionTool.svelte';
	import { capitalize } from '$lib/utils/strings';
	import { t } from 'svelte-i18n';

	export let operation: OperationModel;
</script>

{#if operation.scoringRevenue && operation.scoringEquity && operation.scoringDept && operation.scoringLiquidity && operation.scoringReservationRate && operation.scoringCoverageCostPrice && operation.scoringSecurityOwnFunds && operation.scoringTechnicalSecurity && operation.scoringGlobal}
	<section>
		<h2>{capitalize($t('operation.decisionTool'))}</h2>
		<p class="pb-6">{@html $t('decisionTool.html')}</p>
		<DecisionTool
			scores={[
				operation.scoringRevenue,
				operation.scoringEquity,
				operation.scoringDept,
				operation.scoringLiquidity,
				operation.scoringReservationRate,
				operation.scoringCoverageCostPrice,
				operation.scoringSecurityOwnFunds,
				operation.scoringTechnicalSecurity
			]}
			totalScore={operation.scoringGlobal}
		/>
	</section>
{/if}
